<tcm-main-frame [isLoading]="isLoading" titleKey="Screens.MedicalReport.Details.Title">
  <ng-container commands *ngIf="viewModel?.form">
    <button actionButton templateType="Save" class="me-2" (click)="save()" [disabled]="isReadOnly || !ngForm || ngForm.pristine"></button>
    <button actionButton templateType="SaveExit" class="me-2" (click)="saveAndExit()" [disabled]="isReadOnly || !ngForm || ngForm.pristine"></button>
    <button class="btn btn-default me-4"
            (click)="back()">
      {{'Common.SearchActionsAndDetailsActions.Cancel' | translate}}
    </button>
    <button actionButton class="btn btn-complete me-4" *ngIf="viewModel.form.id"
            (click)="print()">
      {{'Common.SearchActionsAndDetailsActions.Print' | translate}}
    </button>
  </ng-container>

  <ng-container body>
    <tcm-details-layout>
      <div *ngIf="viewModel && viewModel.form" form-area>
        <form #medicalReportForm="ngForm">
          <tabs class="mt-3">
            <tab #medicalReportHistoryTab
                 [tabTitle]="'Screens.MedicalReport.History.Title' | translate">
              <div *ngIf="medicalReportHistoryTab.active">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.History.Sections.PatientInformation' | translate }}
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-4">
                            <waf-text-input name="currentHaSkuRight"
                                            [label]="'Screens.MedicalReport.Fields.CurrentHaSkuRight' | translate"
                                            [(ngModel)]="viewModel.form.currentHaSkuRight"
                                            [maxLength]="15"
                                            [isReadonlyValue]="isReadOnly">
                            </waf-text-input>
                          </div>
                          <div class="col-md-4">
                            <waf-text-input name="currentHaSkuLeft"
                                            [label]="'Screens.MedicalReport.Fields.CurrentHaSkuLeft' | translate"
                                            [(ngModel)]="viewModel.form.currentHaSkuLeft"
                                            [maxLength]="15"
                                            [isReadonlyValue]="isReadOnly">
                            </waf-text-input>
                          </div>
                          <div class="col-md-4">
                            <waf-select-input name="appointmentId"
                                              [label]="'Screens.MedicalReport.Fields.AppointmentId' | translate"
                                              [(ngModel)]="viewModel.form.appointmentId"
                                              (ngModelChange)="appointmentChanged()"
                                              [isReadonlyValue]="(viewModel.form.appointmentId && !viewModel.form.patientId && !viewModel.form.salesOrderId) || isReadOnly"
                                              [options]="viewModel.appointmentOptions"
                                              [allowClear]="true">
                              <ng-template select-option-tmp select-label-tmp
                                           let-option="option">
                                {{ option.startDateTime | wafDateTime }} - {{option.displayName}}
                              </ng-template>
                            </waf-select-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <waf-select-input name="sumTestedById"
                                              [label]="'Screens.MedicalReport.Fields.SumTestedById' | translate"
                                              [(ngModel)]="viewModel.form.sumTestedById"
                                              [isReadonlyValue]="true"
                                              [options]="viewModel.providerOptions"
                                              [allowClear]="true"></waf-select-input>
                          </div>
                          <div class="col-md-4">
                            <waf-date-input name="dateOfTest"
                                            [label]="'Screens.MedicalReport.Fields.DateOfTest' | translate"
                                            [isReadonlyValue]="true"
                                            [(ngModel)]="viewModel.form.dateOfTest">
                            </waf-date-input>
                          </div>
                          <div class="col-md-4">
                            <waf-date-input name="lastFitted"
                                            [label]="'Screens.MedicalReport.Fields.LastFitted' | translate"
                                            [isReadonlyValue]="isReadOnly"
                                            [(ngModel)]="viewModel.form.lastFitted"></waf-date-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <waf-select-input name="purposeOfVisit"
                                              [label]="'Screens.MedicalReport.Fields.PurposeOfVisit' | translate"
                                              [(ngModel)]="viewModel.form.purposeOfVisit"
                                              [options]="purposeOfVisitOptions"
                                              [isReadonlyValue]="isReadOnly || !specialActionPermissions.allowToEditMedicalReportPurposeOfVisit.canExecute"
                                              [allowClear]="true"></waf-select-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.History.Title' | translate }}
                        <span class="help-icon" (click)="openHelpTooltip(historyHelp)">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="card">
                          <div class="card-header">
                            {{ 'Screens.MedicalReport.History.Sections.FDAQuestions' | translate }}
                          </div>
                          <div class="card-body">
                            <div class="row">
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.HearingLoss' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="hearinLossEar"
                                                      [label]="'Screens.MedicalReport.Fields.Ear' | translate"
                                                      [(ngModel)]="viewModel.form.hearinLossEar"
                                                      [options]="earOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="hearinLossDur"
                                                      [label]="'Screens.MedicalReport.Fields.Durn' | translate"
                                                      [(ngModel)]="viewModel.form.hearinLossDur"
                                                      [options]="durnOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.Pain' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="painEar"
                                                      [label]="'Screens.MedicalReport.Fields.Ear' | translate"
                                                      [(ngModel)]="viewModel.form.painEar"
                                                      [options]="earOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="painDur"
                                                      [label]="'Screens.MedicalReport.Fields.Durn' | translate"
                                                      [(ngModel)]="viewModel.form.painDur"
                                                      [options]="durnOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.Drainage' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="drainageEar"
                                                      [label]="'Screens.MedicalReport.Fields.Ear' | translate"
                                                      [(ngModel)]="viewModel.form.drainageEar"
                                                      [options]="earOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="drainageDur"
                                                      [label]="'Screens.MedicalReport.Fields.Durn' | translate"
                                                      [(ngModel)]="viewModel.form.drainageDur"
                                                      [options]="durnOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.Tinnitus' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="tinnitusEar"
                                                      [label]="'Screens.MedicalReport.Fields.Ear' | translate"
                                                      [(ngModel)]="viewModel.form.tinnitusEar"
                                                      [options]="earOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="tinnitusDur"
                                                      [label]="'Screens.MedicalReport.Fields.Durn' | translate"
                                                      [(ngModel)]="viewModel.form.tinnitusDur"
                                                      [options]="durnOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.Equilibrium' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="equilibriumType"
                                                      [label]="'Screens.MedicalReport.Fields.Type' | translate"
                                                      [(ngModel)]="viewModel.form.equilibriumType"
                                                      [options]="typeOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="equilibriumDur"
                                                      [label]="'Screens.MedicalReport.Fields.Durn' | translate"
                                                      [(ngModel)]="viewModel.form.equilibriumDur"
                                                      [options]="durnOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.AuricularDefect' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="auricularDefectEar"
                                                      [label]="'Screens.MedicalReport.Fields.Ear' | translate"
                                                      [(ngModel)]="viewModel.form.auricularDefectEar"
                                                      [options]="earOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.OtoscopicWax' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="otoscopicWaxEar"
                                                      [label]="'Screens.MedicalReport.Fields.Ear' | translate"
                                                      [(ngModel)]="viewModel.form.otoscopicWaxEar"
                                                      [options]="earOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.OtitisMedia' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="otitisMediaEar"
                                                      [label]="'Screens.MedicalReport.Fields.Ear' | translate"
                                                      [(ngModel)]="viewModel.form.otitisMediaEar"
                                                      [options]="earOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="otitisMediaDur"
                                                      [label]="'Screens.MedicalReport.Fields.Durn' | translate"
                                                      [(ngModel)]="viewModel.form.otitisMediaDur"
                                                      [options]="durnOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                              <div class="col-md-4">
                                <div class="row">
                                  <div class="col-md-4 questions-label-container">
                                    <label
                                           class="questions-label">{{ 'Screens.MedicalReport.Fields.PrevHearLossDiag' | translate }}</label>
                                  </div>
                                  <div class="col-md-4">
                                    <waf-select-input name="prevHearLossDiagEar"
                                                      [label]="'Screens.MedicalReport.Fields.Ear' | translate"
                                                      [(ngModel)]="viewModel.form.prevHearLossDiagEar"
                                                      [options]="earOptions"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [allowClear]="true">
                                    </waf-select-input>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="card">
                                  <div class="card-header">
                                    {{ 'Screens.MedicalReport.History.Sections.GeneralQuestions' | translate }}
                                  </div>
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <waf-select-input name="hearingAidUse"
                                                          [label]="'Screens.MedicalReport.Fields.HearingAidUse' | translate"
                                                          [(ngModel)]="viewModel.form.hearingAidUse"
                                                          [options]="earOptions"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-text-input name="historyYearPurchasedAid"
                                                        [label]="'Screens.MedicalReport.Fields.HistoryYearPurchasedAid' | translate"
                                                        [(ngModel)]="viewModel.form.historyYearPurchasedAid"
                                                        [isReadonlyValue]="isReadOnly"
                                                        [maxLength]="4"></waf-text-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-select-input name="patientSatisfaction"
                                                          [label]="'Screens.MedicalReport.Fields.PatientSatisfaction' | translate"
                                                          [(ngModel)]="viewModel.form.patientSatisfaction"
                                                          [options]="patientSatisfactionOptions"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <waf-select-input name="noiseExposure"
                                                          [label]="'Screens.MedicalReport.Fields.NoiseExposure' | translate"
                                                          [(ngModel)]="viewModel.form.noiseExposure"
                                                          [options]="medicalReportConfirmationOptions"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-select-input name="familialLoss"
                                                          [label]="'Screens.MedicalReport.Fields.FamilialLoss' | translate"
                                                          [(ngModel)]="viewModel.form.familialLoss"
                                                          [options]="medicalReportConfirmationOptions"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="card">
                                  <div class="card-header">
                                    {{ 'Screens.MedicalReport.History.Sections.SelfAssessmentOfCommunication' | translate }}
                                  </div>
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <waf-select-input name="oneOnOneSituations"
                                                          [label]="'Screens.MedicalReport.Fields.OneOnOneSituations' | translate"
                                                          [(ngModel)]="viewModel.form.oneOnOneSituations"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [options]="sACLevelOptions"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-select-input name="tVAndEntertainment"
                                                          [label]="'Screens.MedicalReport.Fields.TVAndEntertainment' | translate"
                                                          [(ngModel)]="viewModel.form.tvAndEntertainment"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [options]="sACLevelOptions"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-select-input name="smallGroups"
                                                          [label]="'Screens.MedicalReport.Fields.SmallGroups' | translate"
                                                          [(ngModel)]="viewModel.form.smallGroups"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [options]="sACLevelOptions"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <waf-select-input name="backgroundNoise"
                                                          [label]="'Screens.MedicalReport.Fields.BackgroundNoise' | translate"
                                                          [(ngModel)]="viewModel.form.backgroundNoise"
                                                          [options]="sACLevelOptions"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-select-input name="communicationDifficulties"
                                                          [label]="'Screens.MedicalReport.Fields.CommunicationDifficulties' | translate"
                                                          [(ngModel)]="viewModel.form.communicationDifficulties"
                                                          [options]="sACLevelOptions"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-select-input name="environmentalSounds"
                                                          [label]="'Screens.MedicalReport.Fields.EnvironmentalSounds' | translate"
                                                          [(ngModel)]="viewModel.form.environmentalSounds"
                                                          [options]="sACLevelOptions"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <waf-select-input name="negativeEffectOnSocial"
                                                          [label]="'Screens.MedicalReport.Fields.NegativeEffectOnSocial' | translate"
                                                          [(ngModel)]="viewModel.form.negativeEffectOnSocial"
                                                          [options]="sACLevelOptions"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-select-input name="annoying"
                                                          [label]="'Screens.MedicalReport.Fields.Annoying' | translate"
                                                          [(ngModel)]="viewModel.form.annoying"
                                                          [isReadonlyValue]="isReadOnly"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [options]="sACLevelOptions"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-select-input name="otherSuggestedHearingProblems"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [label]="'Screens.MedicalReport.Fields.OtherSuggestedHearingProblems' | translate"
                                                          [(ngModel)]="viewModel.form.otherSuggestedHearingProblems"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [options]="sACLevelOptions"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <waf-select-input name="affectsEnjoinmentOfLife"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [label]="'Screens.MedicalReport.Fields.AffectsEnjoymentOfLife' | translate"
                                                          [(ngModel)]="viewModel.form.affectsEnjoinmentOfLife"
                                                          (ngModelChange)="updateSacTotalScore()"
                                                          [options]="sACLevelOptions"
                                                          [allowClear]="true"></waf-select-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-number-input name="sACTotalScore"
                                                          [label]="'Screens.MedicalReport.Fields.SACTotalScore' | translate"
                                                          [(ngModel)]="viewModel.form.saCTotalScore"
                                                          [isReadonlyValue]="isReadOnly"
                                                          [allowClear]="true"></waf-number-input>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <div class="row">
                              <div class="col-md-12">
                                <div class="card">
                                  <div class="card-header">
                                    {{ 'Screens.MedicalReport.History.Sections.PediatricHistory' | translate }}
                                  </div>
                                  <div class="card-body">
                                    <div class="row">
                                      <div class="col-md-4">
                                        <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                           name="peTubeRight"
                                                           [isReadonlyValue]="isReadOnly"
                                                           [label]="'Screens.MedicalReport.Fields.PeTubeRight' | translate"
                                                           [(ngModel)]="viewModel.form.peTubeRight">
                                        </waf-boolean-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                           name="peTubeLeft"
                                                           [isReadonlyValue]="isReadOnly"
                                                           [label]="'Screens.MedicalReport.Fields.PeTubeLeft' | translate"
                                                           [(ngModel)]="viewModel.form.peTubeLeft">
                                        </waf-boolean-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                           name="failScreen"
                                                           [isReadonlyValue]="isReadOnly"
                                                           [label]="'Screens.MedicalReport.Fields.FailScreen' | translate"
                                                           [(ngModel)]="viewModel.form.failScreen">
                                        </waf-boolean-input>
                                      </div>
                                    </div>
                                    <div class="row">
                                      <div class="col-md-4">
                                        <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                           name="nICU"
                                                           [isReadonlyValue]="isReadOnly"
                                                           [label]="'Screens.MedicalReport.Fields.NICU' | translate"
                                                           [(ngModel)]="viewModel.form.niCU">
                                        </waf-boolean-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                           name="attnDifficulty"
                                                           [isReadonlyValue]="isReadOnly"
                                                           [label]="'Screens.MedicalReport.Fields.AttnDifficulty' | translate"
                                                           [(ngModel)]="viewModel.form.attnDifficulty">
                                        </waf-boolean-input>
                                      </div>
                                      <div class="col-md-4">
                                        <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                           name="spLangDis"
                                                           [isReadonlyValue]="isReadOnly"
                                                           [label]="'Screens.MedicalReport.Fields.SpLangDis' | translate"
                                                           [(ngModel)]="viewModel.form.spLangDis">
                                        </waf-boolean-input>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.History.Sections.HistoryNotes' | translate }}
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <waf-text-input name="notes" [multiline]="true"
                                            [(ngModel)]="viewModel.form.notes"
                                            [maxLength]="8000"
                                            [isReadonlyValue]="isReadOnly">
                            </waf-text-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab>
            <tab #medicalReportNoahSession
                 [tabTitle]="'Screens.MedicalReport.NoahSession.Title' | translate">
              <div *ngIf="medicalReportNoahSession.active">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-4">
                            <waf-select-input name="noahSession"
                                              [label]="'Screens.MedicalReport.Fields.NoahSession' | translate"
                                              [(ngModel)]="viewModel.form.noahActionDataId"
                                              [options]="noahSessionOptions"
                                              (ngModelChange)="updateAudiometryImmittance()"
                                              [allowClear]="true"
                                              [isReadonlyValue]="isReadOnly">
                              <ng-template select-option-tmp select-label-tmp
                                           let-option="option">
                                {{ option.date | date }} - {{option.displayName}}
                              </ng-template>
                            </waf-select-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="viewModel.form.noahActionDataId" class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.NoahSession.Sections.Audiogram' | translate }}
                      </div>
                      <div class="card-body">
                        <noah-audiogram-view [requestModel]="{actionId: viewModel.form.noahActionDataId}">
                        </noah-audiogram-view>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab>
            <tab #medicalReportAudiometryTab
                 [tabTitle]="'Screens.MedicalReport.Audiometry.Title' | translate">
              <div *ngIf="medicalReportAudiometryTab.active">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Audiometry.Sections.AudiometryPureTone' | translate }}
                        <span class="help-icon" (click)="openHelpTooltip(pureToneHelp)">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-md-12">
                                {{ 'Screens.MedicalReport.Audiometry.Sections.RightEar' | translate }}
                              </div>
                            </div>
                            <div class="subsection-group">
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="pureToneAudDegreeR"
                                                    [label]="'Screens.MedicalReport.Fields.PureToneAudDegreeR' | translate"
                                                    [(ngModel)]="viewModel.form.pureToneAudDegreeR"
                                                    [options]="pureToneAudDegreeOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-select-input name="pureToneAudCategoryR"
                                                    [label]="'Screens.MedicalReport.Fields.PureToneAudCategoryR' | translate"
                                                    [(ngModel)]="viewModel.form.pureToneAudCategoryR"
                                                    [options]="pureToneAudCategoryOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="pureToneAudHighFreqR"
                                                    [label]="'Screens.MedicalReport.Fields.PureToneAudHighFreqR' | translate"
                                                    [(ngModel)]="viewModel.form.pureToneAudHighFreqR"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="pureToneAudHighFreqOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-md-12">
                                {{ 'Screens.MedicalReport.Audiometry.Sections.LeftEar'| translate }}
                              </div>
                            </div>
                            <div class="subsection-group">
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="pureToneAudDegreeL"
                                                    [label]="'Screens.MedicalReport.Fields.PureToneAudDegreeL' | translate"
                                                    [(ngModel)]="viewModel.form.pureToneAudDegreeL"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="pureToneAudDegreeOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-select-input name="pureToneAudCategoryL"
                                                    [label]="'Screens.MedicalReport.Fields.PureToneAudCategoryL' | translate"
                                                    [(ngModel)]="viewModel.form.pureToneAudCategoryL"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="pureToneAudCategoryOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="pureToneAudHighFreqL"
                                                    [label]="'Screens.MedicalReport.Fields.PureToneAudHighFreqL' | translate"
                                                    [(ngModel)]="viewModel.form.pureToneAudHighFreqL"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="pureToneAudHighFreqOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-md-12">
                                {{ 'Screens.MedicalReport.Fields.PureToneAudStimulusMethod' | translate }}
                              </div>
                            </div>
                            <div class="subsection-group">
                              <div class="row">
                                <div class="col-md-12">
                                  <waf-select-input name="pureToneAudStimulusMethod"
                                                    [label]=""
                                                    [(ngModel)]="viewModel.form.pureToneAudStimulusMethod"
                                                    [options]="pureToneAudStimulusMethodOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Audiometry.Sections.AudiometrySpeech' | translate }}
                        <span class="help-icon" (click)="openHelpTooltip(speechHelp)">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6 ">
                            <div class="row">
                              <div class="col-md-12">
                                {{ 'Screens.MedicalReport.Audiometry.Sections.RightEar' | translate }}
                              </div>
                            </div>
                            <div class="subsection-group">
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="speechAudSRTDiscR"
                                                    [label]="'Screens.MedicalReport.Fields.SpeechAudSRTDiscR' | translate"
                                                    [(ngModel)]="viewModel.form.speechAudSRTDiscR"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="speechAudSRTDiscOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-select-input name="speechAudPTASatR"
                                                    [label]="'Screens.MedicalReport.Fields.SpeechAudPTASatR' | translate"
                                                    [(ngModel)]="viewModel.form.speechAudPTASatR"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="speechAudPTASatOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="recognR"
                                                    [label]="'Screens.MedicalReport.Fields.RecognR' | translate"
                                                    [(ngModel)]="viewModel.form.recognR"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="recognOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-md-12">
                                {{'Screens.MedicalReport.Audiometry.Sections.LeftEar' | translate}}
                              </div>
                            </div>
                            <div class="subsection-group">
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="speechAudSRTDiscL"
                                                    [label]="'Screens.MedicalReport.Fields.SpeechAudSRTDiscL' | translate"
                                                    [(ngModel)]="viewModel.form.speechAudSRTDiscL"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="speechAudSRTDiscOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-select-input name="speechAudPTASatL"
                                                    [label]="'Screens.MedicalReport.Fields.SpeechAudPTASatL' | translate"
                                                    [(ngModel)]="viewModel.form.speechAudPTASatL"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="speechAudPTASatOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="recognL"
                                                    [label]="'Screens.MedicalReport.Fields.RecognL' | translate"
                                                    [(ngModel)]="viewModel.form.recognL"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [options]="recognOptions"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="row">
                              <div class="col-md-12">
                                {{ 'Screens.MedicalReport.Fields.SpeechAudBIDisc' | translate }}
                              </div>
                            </div>
                            <div class="subsection-group">
                              <div class="row">
                                <div class="col-md-4">
                                  <div class="row">
                                    <div class="col-md-7">
                                      <waf-select-input name="speechAudBIDisc"
                                                        [label]=""
                                                        [(ngModel)]="viewModel.form.speechAudBIDisc"
                                                        [options]="speechAudBIDiscOptions"
                                                        [isReadonlyValue]="isReadOnly"
                                                        [allowClear]="true">
                                      </waf-select-input>
                                    </div>
                                    <div class="col-md-1">
                                      {{ 'Screens.MedicalReport.Fields.SpeechAudBIDiscPercent' | translate }}
                                    </div>
                                    <div class="col-md-4">
                                      <waf-text-input name="speechAudBIDiscPercent"
                                                      [label]=""
                                                      [(ngModel)]="viewModel.form.speechAudBIDiscPercent"
                                                      [isReadonlyValue]="isReadOnly"
                                                      [maxLength]="15">
                                      </waf-text-input>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Audiometry.Sections.SpecialTestingComment' | translate }}
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <waf-text-input name="specialTestComments"
                                            [multiline]="true"
                                            [label]=""
                                            [(ngModel)]="viewModel.form.specialTestComments"
                                            [isReadonlyValue]="isReadOnly"
                                            [maxLength]="8000">
                            </waf-text-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Audiometry.Sections.ImmittanceTesting' | translate }}
                        <span class="help-icon" (click)="openHelpTooltip(immittanceHelp)">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-md-12">
                                {{ 'Screens.MedicalReport.Audiometry.Sections.RightEar' | translate }}
                              </div>
                            </div>
                            <div class="subsection-group">
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="immMidEarEvalTympR"
                                                    [label]="'Screens.MedicalReport.Fields.ImmMidEarEvalTympR' | translate"
                                                    [(ngModel)]="viewModel.form.immMidEarEvalTympR"
                                                    [options]="immMidEarEvalTympOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-select-input name="immMidEarReflexDecayR"
                                                    [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexDecayR' | translate"
                                                    [(ngModel)]="viewModel.form.immMidEarReflexDecayR"
                                                    [options]="medicalReportConfirmationOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true"></waf-select-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="immMidEarReflexContraR"
                                                    [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexContraR' | translate"
                                                    [(ngModel)]="viewModel.form.immMidEarReflexContraR"
                                                    [options]="immMidEarReflexOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-select-input name="immMidEarReflexIpsiR"
                                                    [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexIpsiR' | translate"
                                                    [(ngModel)]="viewModel.form.immMidEarReflexIpsiR"
                                                    [options]="immMidEarReflexOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-boolean-input name="immMidEarReflexConsistantR"
                                                     [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexConsistantR' | translate"
                                                     [(ngModel)]="viewModel.form.immMidEarReflexConsistantR"
                                                     [isReadonlyValue]="isReadOnly">
                                  </waf-boolean-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-boolean-input name="immMidEarReflexIpsiConsistantR"
                                                     [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexIpsiConsistantR' | translate"
                                                     [(ngModel)]="viewModel.form.immMidEarReflexIpsiConsistantR"
                                                     [isReadonlyValue]="isReadOnly">
                                  </waf-boolean-input>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="row">
                              <div class="col-md-12">
                                {{ 'Screens.MedicalReport.Audiometry.Sections.LeftEar' | translate }}
                              </div>
                            </div>
                            <div class="subsection-group">
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="immMidEarEvalTympL"
                                                    [label]="'Screens.MedicalReport.Fields.ImmMidEarEvalTympR' | translate"
                                                    [(ngModel)]="viewModel.form.immMidEarEvalTympL"
                                                    [options]="immMidEarEvalTympOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-select-input name="immMidEarReflexDecayL"
                                                    [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexDecayL' | translate"
                                                    [(ngModel)]="viewModel.form.immMidEarReflexDecayL"
                                                    [options]="medicalReportConfirmationOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true"></waf-select-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-select-input name="immMidEarReflexContraL"
                                                    [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexContraR' | translate"
                                                    [(ngModel)]="viewModel.form.immMidEarReflexContraL"
                                                    [options]="immMidEarReflexOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-select-input name="immMidEarReflexIpsiL"
                                                    [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexIpsiR' | translate"
                                                    [(ngModel)]="viewModel.form.immMidEarReflexIpsiL"
                                                    [options]="immMidEarReflexOptions"
                                                    [isReadonlyValue]="isReadOnly"
                                                    [allowClear]="true">
                                  </waf-select-input>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-6">
                                  <waf-boolean-input name="immMidEarReflexConsistantL"
                                                     [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexConsistantR' | translate"
                                                     [(ngModel)]="viewModel.form.immMidEarReflexConsistantL"
                                                     [isReadonlyValue]="isReadOnly">
                                  </waf-boolean-input>
                                </div>
                                <div class="col-md-6">
                                  <waf-boolean-input name="immMidEarReflexIpsiConsistantL"
                                                     [label]="'Screens.MedicalReport.Fields.ImmMidEarReflexIpsiConsistantR' | translate"
                                                     [(ngModel)]="viewModel.form.immMidEarReflexIpsiConsistantL"
                                                     [isReadonlyValue]="isReadOnly">
                                  </waf-boolean-input>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Fields.NoahSession' | translate }}
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-4">
                            <waf-select-input name="noahActionDataId" label=""
                                              [(ngModel)]="viewModel.form.noahActionDataId"
                                              [options]="noahSessionOptions"
                                              [allowClear]="true"
                                              (ngModelChange)="updateAudiometryImmittance()"
                                              [isReadonlyValue]="isReadOnly">
                              <ng-template select-option-tmp select-label-tmp
                                           let-option="option">
                                {{ option.date | date }} - {{option.displayName}}
                              </ng-template>
                            </waf-select-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab>
            <tab #summary
                 [tabTitle]="'Screens.MedicalReport.Summary.Title' | translate">
              <div *ngIf="summary.active">
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Summary.Sections.Summary' | translate }}
                        <span class="help-icon" (click)="openHelpTooltip(summaryHelp)">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-4">
                            <waf-select-input name="results"
                                              [label]="'Screens.MedicalReport.Fields.Results' | translate"
                                              [(ngModel)]="viewModel.form.results"
                                              [options]="resultOptions"
                                              [allowClear]="true"
                                              [isReadonlyValue]="isReadOnly">
                            </waf-select-input>
                          </div>
                          <div class="col-md-4">
                            <waf-select-input name="haNeeded"
                                              [label]="'Screens.MedicalReport.Fields.HaNeeded' | translate"
                                              [(ngModel)]="viewModel.form.haNeeded"
                                              [options]="recomOptions"
                                              [allowClear]="true"
                                              [isReadonlyValue]="true">
                            </waf-select-input>
                          </div>
                          <div class="col-md-4">
                            <waf-select-input name="estimatedThresholds"
                                              [isReadonlyValue]="isReadOnly"
                                              [label]="'Screens.MedicalReport.Fields.EstimatedThresholds' | translate"
                                              [(ngModel)]="viewModel.form.estimatedThresholds"
                                              [options]="estimatedThreshholdOptions"
                                              [allowClear]="true">
                            </waf-select-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Summary.Sections.Notes' | translate }}
                        <span class="help-icon" (click)="openHelpTooltip(notesHelp)">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="card-body">
                          <div class="row">
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="medicalClearance"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.MedicalClearance' | translate"
                                                 [(ngModel)]="viewModel.form.medicalClearance">
                              </waf-boolean-input>
                            </div>
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="unilateralTinnitus"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.UnilateralTinnitus' | translate"
                                                 [(ngModel)]="viewModel.form.unilateralTinnitus">
                              </waf-boolean-input>
                            </div>
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="asymmetry"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.Asymmetry' | translate"
                                                 [(ngModel)]="viewModel.form.asymmetry">
                              </waf-boolean-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="eUSTubeDys"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.EUSTubeDys' | translate"
                                                 [(ngModel)]="viewModel.form.euSTubeDys">
                              </waf-boolean-input>
                            </div>
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="cerumenRemoved"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.CerumenRemoved' | translate"
                                                 [(ngModel)]="viewModel.form.cerumenRemoved">
                              </waf-boolean-input>
                            </div>
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="thresholdShift"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.ThresholdShift' | translate"
                                                 [(ngModel)]="viewModel.form.thresholdShift">
                              </waf-boolean-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="retrocochlear"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.Retrocochlear' | translate"
                                                 [(ngModel)]="viewModel.form.retrocochlear">
                              </waf-boolean-input>
                            </div>
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="cochlear"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.Cochlear' | translate"
                                                 [(ngModel)]="viewModel.form.cochlear">
                              </waf-boolean-input>
                            </div>
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="soundfield"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.Soundfield' | translate"
                                                 [(ngModel)]="viewModel.form.soundfield">
                              </waf-boolean-input>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="peTubeDys"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.PeTubeDys' | translate"
                                                 [(ngModel)]="viewModel.form.peTubeDys">
                              </waf-boolean-input>
                            </div>
                            <div class="col-md-4">
                              <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                                 name="testReliability"
                                                 [isReadonlyValue]="isReadOnly"
                                                 [label]="'Screens.MedicalReport.Fields.TestReliability' | translate"
                                                 [(ngModel)]="viewModel.form.testReliability">
                              </waf-boolean-input>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Summary.Sections.Recommendations' | translate }}
                        <span class="help-icon" (click)="openHelpTooltip(recommendationsHelp)">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="retest"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.Retest' | translate"
                                               [(ngModel)]="viewModel.form.retest">
                            </waf-boolean-input>
                          </div>
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="cerumenRemoval"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.CerumenRemoval' | translate"
                                               [(ngModel)]="viewModel.form.cerumenRemoval">
                            </waf-boolean-input>
                          </div>
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="yearlyEvaluation"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.YearlyEvaluation' | translate"
                                               [(ngModel)]="viewModel.form.yearlyEvaluation">
                            </waf-boolean-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="medicalConsultation"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.MedicalConsultation' | translate"
                                               [(ngModel)]="viewModel.form.medicalConsultation">
                            </waf-boolean-input>
                          </div>
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="eNG"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.ENG' | translate"
                                               [(ngModel)]="viewModel.form.enG">
                            </waf-boolean-input>
                          </div>
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="aBR"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.ABR' | translate"
                                               [(ngModel)]="viewModel.form.abR">
                            </waf-boolean-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="auralRehab"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.AuralRehab' | translate"
                                               [(ngModel)]="viewModel.form.auralRehab">
                            </waf-boolean-input>
                          </div>
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="replaceAids"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.ReplaceAids' | translate"
                                               [(ngModel)]="viewModel.form.replaceAids">
                            </waf-boolean-input>
                          </div>
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="educationalIntervention"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.EducationalIntervention' | translate"
                                               [(ngModel)]="viewModel.form.educationalIntervention">
                            </waf-boolean-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="preferentialSeating"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.PreferentialSeating' | translate"
                                               [(ngModel)]="viewModel.form.preferentialSeating">
                            </waf-boolean-input>
                          </div>
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="hAAfterMedConsult"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.HAAfterMedConsult' | translate"
                                               [(ngModel)]="viewModel.form.haAfterMedConsult">
                            </waf-boolean-input>
                          </div>
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="hearingProtection"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.HearingProtection' | translate"
                                               [(ngModel)]="viewModel.form.hearingProtection">
                            </waf-boolean-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <waf-boolean-input controlIndicatorClass="toggle-button-control-indicator"
                                               name="binauralComplete"
                                               [isReadonlyValue]="isReadOnly"
                                               [label]="'Screens.MedicalReport.Fields.BinauralComplete' | translate"
                                               [(ngModel)]="viewModel.form.binauralComplete">
                            </waf-boolean-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Summary.Sections.HearingAidRecommended' | translate }}
                        <span class="help-icon" (click)="openHelpTooltip(haRecommendationHelp)">
                          <i class="fa fa-question-circle" aria-hidden="true"></i>
                        </span>
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-4">
                            <waf-select-input name="recom"
                                              [label]="'Screens.MedicalReport.Fields.Recom' | translate"
                                              [(ngModel)]="viewModel.form.recom"
                                              [options]="recomOptions"
                                              [allowClear]="true"
                                              [isReadonlyValue]="isReadOnly">
                            </waf-select-input>
                          </div>
                          <div class="col-md-4">
                            <waf-select-input name="level"
                                              [label]="'Screens.MedicalReport.Fields.Level' | translate"
                                              [(ngModel)]="viewModel.form.level"
                                              [options]="levelOptions"
                                              [allowClear]="true"
                                              [isReadonlyValue]="isReadOnly">
                            </waf-select-input>
                          </div>
                          <div class="col-md-4">
                            <waf-select-input name="outcome"
                                              [label]="'Screens.MedicalReport.Fields.Outcome' | translate"
                                              [(ngModel)]="viewModel.form.outcome"
                                              [options]="outcomeOptions"
                                              [allowClear]="true"
                                              [isReadonlyValue]="isReadOnly">
                            </waf-select-input>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <waf-select-input name="return"
                                              [label]="'Screens.MedicalReport.Fields.Return' | translate"
                                              [(ngModel)]="viewModel.form.return"
                                              [options]="returnOptions"
                                              [allowClear]="true"
                                              [isReadonlyValue]="isReadOnly">
                            </waf-select-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="card">
                      <div class="card-header">
                        {{ 'Screens.MedicalReport.Summary.Sections.Remarks' | translate }}
                      </div>
                      <div class="card-body">
                        <div class="row">
                          <div class="col-md-12">
                            <waf-text-input name="remarks" [multiline]="true" [label]=""
                                            [maxLength]=8000
                                            [(ngModel)]="viewModel.form.remarks"
                                            [isReadonlyValue]="isReadOnly">
                            </waf-text-input>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </tab>
          </tabs>
        </form>
      </div>
    </tcm-details-layout>
  </ng-container>
</tcm-main-frame>

<ng-template #validationAlertTemplate let-data="data">
  <div *ngFor="let error of data" class="alert alert-error" role="alert">
    <span class="alert-text">{{error}}</span>
  </div>
</ng-template>

<ng-template #recommendationMessageTemplate let-data="data">
  {{'Screens.MedicalReport.ValidationMessages.HARecommendationIs' | translate}} <b>{{data.oldValue}}</b> <br />
  {{'Screens.MedicalReport.ValidationMessages.HARecommendationShouldBe' | translate}} <b>{{data.newValue}}</b> <br />
  {{'Screens.MedicalReport.ValidationMessages.HARecommendationIsDifferentQuestion' | translate}}
</ng-template>

<ng-template #historyHelp>
  <div class="groupValueContainer">
    <b>{{ 'Screens.MedicalReport.Fields.HearingLoss' | translate }}:</b>

    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.HearingLoss.Paragraph1' | translate}}
    </p>
  </div>
  <div class="groupValueContainer">
    <b>
      {{ 'Screens.MedicalReport.Fields.Pain' | translate }}:
    </b>

    <p>{{'Screens.MedicalReport.Help.FieldDescription.Pain.Paragraph1' | translate}}
    </p>
  </div>
  <div class="groupValueContainer">
    <b>
      {{ 'Screens.MedicalReport.Fields.Drainage' | translate }}:
    </b>

    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.Drainage.Paragraph1' | translate}}
    </p>

    <b>{{ 'Screens.MedicalReport.Fields.Tinnitus' | translate }}:</b>
    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.Tinnitus.Paragraph1' | translate}}
    </p>

    <b>{{ 'Screens.MedicalReport.Fields.Equilibrium' | translate }}:</b>
    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.Equilibrium.Paragraph1' | translate}}
    </p>

    <b>{{ 'Screens.MedicalReport.Fields.OtoscopicWax' | translate }}:</b>
    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.OtoscopicWax.Paragraph1' | translate}}
    </p>

    <b>{{ 'Screens.MedicalReport.Fields.AuricularDefect' | translate }}:</b>
    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.AuricularDefect.Paragraph1' | translate}}
    </p>

    <b>{{ 'Screens.MedicalReport.Help.FieldDescription.PrevHearLossDiag.Name' | translate }}:</b>
    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.PrevHearLossDiag.Paragraph1' | translate}}
    </p>

    <b>{{ 'Screens.MedicalReport.Fields.FamilialLoss' | translate }}:</b>
    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.FamilialLoss.Paragraph1' | translate}}
    </p>

    <b>{{ 'Screens.MedicalReport.Fields.NoiseExposure' | translate }}:</b>
    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.NoiseExposure.Paragraph1' | translate}}
    </p>

    <b>{{ 'Screens.MedicalReport.Fields.HearingAidUse' | translate }}:</b>
    <p>
      {{'Screens.MedicalReport.Help.FieldDescription.HearingAidUse.Paragraph1' | translate}}
    </p>
  </div>
</ng-template>

<ng-template #haRecommendationHelp>
  <b>
    <a name="hearingaidrecommendation">{{ 'Screens.MedicalReport.Summary.Sections.HearingAidRecommended' | translate }}:</a>
  </b>
  <p>
    {{'Screens.MedicalReport.Help.FieldDescription.Recom.Paragraph1' | translate}}
    <br /><br />
    {{'Screens.MedicalReport.Help.FieldDescription.Recom.Paragraph2' | translate}}
    <br /><br />
    {{'Screens.MedicalReport.Help.FieldDescription.Recom.Paragraph3' | translate}}
  </p>
</ng-template>

<ng-template #immittanceHelp>
  <b><a name="immittance">{{'Screens.MedicalReport.Help.Immittance.Name' | translate}}:</a></b>
  <br />

  <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Name' | translate}}:</b>
  <p>
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.AdultCriteria' | translate}}:</b>
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.A.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.A.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.As.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.As.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.B.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.B.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.C.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.C.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.Ad.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.Ad.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.PerfPpet.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.PerfPpet.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.Inc.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.Values.Inc.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.InChildren.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Tymp.InChildren.Descriprtion' | translate}}
  </p>

  <b>{{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Name' | translate}}:</b>
  <p>
    {{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Wnl.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Wnl.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Absent.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Absent.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Reduced.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Reduced.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Elevated.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Elevated.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Inc.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Inc.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Cnt.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.ContraReflex.Values.Cnt.Descriprtion' | translate}}
  </p>

  <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Decay.Name' | translate}}:</b>
  <p>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Decay.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Decay.Values.Yes.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Decay.Values.Yes.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Decay.Values.No.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Decay.Values.No.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.Decay.Values.Cnt.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.Decay.Values.Cnt.Descriprtion' | translate}}
  </p>

  <b>{{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Name' | translate}}:</b>
  <p>
    {{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Wnl.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Wnl.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Absent.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Absent.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Reduced.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Reduced.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Elevated.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Elevated.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Inc.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Inc.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Cnt.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Immittance.Fields.IpsiReflex.Values.Cnt.Descriprtion' | translate}}
  </p>
</ng-template>

<ng-template #notesHelp>
  <b>
    {{ 'Screens.MedicalReport.Summary.Sections.Notes' | translate }}:
  </b>
  <p>
    <b>{{'Screens.MedicalReport.Help.Notes.MedicalClearance.Name' | translate}} – </b>
    {{'Screens.MedicalReport.Help.Notes.MedicalClearance.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.ConductiveLoss.Name' | translate}}: </b>
    {{'Screens.MedicalReport.Help.Notes.ConductiveLoss.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.SnLoss.Name' | translate}}: </b>
    {{'Screens.MedicalReport.Help.Notes.SnLoss.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.UnilateralTinnitus.Name' | translate}} – </b>
    {{'Screens.MedicalReport.Help.Notes.UnilateralTinnitus.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.Asymmetry.Name' | translate}} – </b>
    {{'Screens.MedicalReport.Help.Notes.Asymmetry.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.Speech.Name' | translate}}: </b>
    {{'Screens.MedicalReport.Help.Notes.Speech.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.PureTones.Name' | translate}}: </b>
    {{'Screens.MedicalReport.Help.Notes.PureTones.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.HearxWest.Name' | translate}}- </b>
    {{'Screens.MedicalReport.Help.Notes.HearxWest.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.EusTubeDys.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Notes.EusTubeDys.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.CerumenRemoved.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Notes.CerumenRemoved.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.ThresholdShift.Name' | translate}} – </b>
    {{'Screens.MedicalReport.Help.Notes.ThresholdShift.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.HearxWest2.Name' | translate}} – </b>
    {{'Screens.MedicalReport.Help.Notes.HearxWest2.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.Retrocochlear.Name' | translate}} – </b>
    {{'Screens.MedicalReport.Help.Notes.Retrocochlear.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.DoNotCheck1.Name' | translate}}: </b>
    {{'Screens.MedicalReport.Help.Notes.DoNotCheck1.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.DoNotCheck2.Name' | translate}}: </b>
    {{'Screens.MedicalReport.Help.Notes.DoNotCheck2.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.Cochlear.Name' | translate}} – </b>
    {{'Screens.MedicalReport.Help.Notes.Cochlear.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.SoundField.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Notes.SoundField.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Notes.PeTubeDys.Name' | translate}} - </b>
    {{'Screens.MedicalReport.Help.Notes.PeTubeDys.Description' | translate}}
    <br />
    {{'Screens.MedicalReport.Help.Notes.RecommendRetest.Description' | translate}}
    <br />
    <b>? {{'Screens.MedicalReport.Help.Notes.Reliability.Name' | translate}} – </b>
    {{'Screens.MedicalReport.Help.Notes.Reliability.Description' | translate}}
  </p>
</ng-template>

<ng-template #pureToneHelp>
  <b>{{'Screens.MedicalReport.Help.PureTone.Name' | translate}}:</b>
  <br />
  <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Name' | translate}}:</b>
  <p>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Normal.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Normal.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Slight.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Slight.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Mild.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Mild.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Moderate.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Moderate.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Severe.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Severe.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Profound.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Degree.Values.Profound.Descriprtion' | translate}}
  </p>

  <b>{{'Screens.MedicalReport.Help.PureTone.Fields.FreqModif.Name' | translate}}:</b>
  <p>
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.FreqModif.Values.High.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.FreqModif.Values.High.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.FreqModif.Values.Low.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.FreqModif.Values.Low.Descriprtion' | translate}}
  </p>

  <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Category.Name' | translate}}:</b>
  <p>
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Category.Values.Sensorineural.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Category.Values.Sensorineural.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Category.Values.Conductive.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Category.Values.Conductive.Descriprtion' | translate}}
    <br />

    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Category.Values.Mixed.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Category.Values.Mixed.Descriprtion' | translate}}
    <br />

    <b>{{'Screens.MedicalReport.Help.PureTone.Fields.Category.Values.Unspecified.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.PureTone.Fields.Category.Values.Unspecified.Descriprtion' | translate}}
  </p>

  <b>{{'Screens.MedicalReport.Help.PureTone.Fields.StimulusMethod.Name' | translate}}:</b>
  <p>
    {{'Screens.MedicalReport.Help.PureTone.Fields.StimulusMethod.Descriprtion' | translate}}
  </p>
</ng-template>

<ng-template #recommendationsHelp>
  <b>
    <a name="hearingaidrecommendation">{{'Screens.MedicalReport.Help.Recommendations.Name' | translate}}:</a>
  </b>
  <p>
    <b>{{'Screens.MedicalReport.Help.Recommendations.Retest.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.Retest.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.CerumenRemoval.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.CerumenRemoval.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.YearlyEval.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.YearlyEval.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.MedConsultation.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.MedConsultation.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.Criteria.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.Criteria.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.EngVng.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.EngVng.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.Abr.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.Abr.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.AuralRehab.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.AuralRehab.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.ReplaceAids.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.ReplaceAids.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.EducationIntervention.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.EducationIntervention.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.PreferentialSeating.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.PreferentialSeating.Description' | translate}}
    <br /><b>{{'Screens.MedicalReport.Help.Recommendations.Audiologist.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.Audiologist.Description' | translate}}
    <br />
    {{'Screens.MedicalReport.Help.Recommendations.ConditionsThatRequireAudiologist.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Recommendations.HaAfterMedConsult.Name' | translate}} –</b>
    {{'Screens.MedicalReport.Help.Recommendations.HaAfterMedConsult.Description' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Recommendations.Criteria2.Name' | translate}}- </b>
    {{'Screens.MedicalReport.Help.Recommendations.Criteria2.Description' | translate}}
  </p>
</ng-template>

<ng-template #speechHelp>
  <b>{{'Screens.MedicalReport.Help.Speech.Name' | translate}}:</b>
  <br />
  <b>{{'Screens.MedicalReport.Help.Speech.Fields.Srt.Name' | translate}}:</b>
  <p>
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Srt.Name' | translate}}
      {{'Screens.MedicalReport.Help.Speech.Fields.Srt.Values.Pta.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Srt.Values.Pta.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Srt.Name' | translate}}
      {{'Screens.MedicalReport.Help.Speech.Fields.Srt.Values.Poorer.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Srt.Values.Poorer.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Srt.Name' | translate}}
      {{'Screens.MedicalReport.Help.Speech.Fields.Srt.Values.Better.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Srt.Values.Better.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Srt.Name' | translate}}
      {{'Screens.MedicalReport.Help.Speech.Fields.Srt.Values.Cnt.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Srt.Values.Cnt.Descriprtion' | translate}}
    <br />
  </p>

  <b>{{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Name' | translate}}:</b>
  <p>
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Excellent.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Excellent.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Good.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Good.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Fair.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Fair.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Poor.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Poor.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Cnt.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Recogn.Values.Cnt.Descriprtion' | translate}}
    <br />
  </p>

  <b>{{'Screens.MedicalReport.Help.Speech.Fields.Sat.Name' | translate}}:</b>
  <p>
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Wnl.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Wnl.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Slight.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Slight.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Mild.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Mild.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Moderate.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Moderate.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Severe.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Severe.Descriprtion' | translate}}
    <br />
    <b>{{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Profound.Name' | translate}}:</b>
    {{'Screens.MedicalReport.Help.Speech.Fields.Sat.Values.Profound.Descriprtion' | translate}}
    <br />
  </p>
</ng-template>

<ng-template #summaryHelp>
  <div class="groupValueContainer">
    <b>{{'Screens.MedicalReport.Help.Summary.Fields.Results.Name' | translate}}:</b>
    <p>
      {{'Screens.MedicalReport.Help.Summary.Fields.Results.Paragraph1' | translate}}
      <br />
      {{'Screens.MedicalReport.Help.Summary.Fields.Results.Paragraph2' | translate}}
      <br />
      {{'Screens.MedicalReport.Help.Summary.Fields.Results.Paragraph3' | translate}}
    </p>
  </div>
  <div class="groupValueContainer">
    <b>
      {{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Name' | translate}}:
    </b>
    <p>
      {{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Descriprtion' | translate}}
      <br />
      <b>{{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Normal.Name' | translate}}:</b>
      {{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Normal.Descriprtion' | translate}}
      <br />
      <b>{{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Mild.Name' | translate}}:</b>
      {{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Mild.Descriprtion' | translate}}
      <br />
      <b>{{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Moderate.Name' | translate}}:</b>
      {{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Moderate.Descriprtion' | translate}}
      <br />
      <b>{{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Severe.Name' | translate}}:</b>
      {{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Severe.Descriprtion' | translate}}
      <br />
      <b>{{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Profound.Name' | translate}}:</b>
      {{'Screens.MedicalReport.Help.Summary.Fields.EstimatedThresholds.Values.Profound.Descriprtion' | translate}}
      <br />
    </p>
    <b>
      {{'Screens.MedicalReport.Help.Summary.Fields.Notes.Name' | translate}}:
    </b>
    <p>
      {{'Screens.MedicalReport.Help.Summary.Fields.Notes.Descriprtion' | translate}}
    </p>
  </div>
</ng-template>
